module.exports = __webpack_public_path__ + "536b1612004d62a0e9b77aceead7c891.fbx";